export default "__VITE_ASSET__D3n0hQ0v__"